<template>
    <div class="layout">
  
      <!-- Mobile Overlay -->
      <div v-if="isOpen" class="overlay" @click="toggleSidebar"></div>
  
      <!-- Sidebar -->
      <aside :class="['sidebar', { open: isOpen }]">
  
        <!-- Logo -->
        <div class="sidebar-header">
          <img src="../assets/logo.png" alt="Logo" />
          <h5>Angala Farmers</h5>
        </div>
  
        <!-- Menu -->
        <nav class="menu">
          <router-link to="/home" class="menu-item">
            <i class="fa fa-home"></i>
            <span>Dashboard</span>
          </router-link>
  
          <router-link v-if="roles == '1' || roles == '3'" to="/accounts" class="menu-item">
            <i class="fa fa-bank"></i>
            <span>Generate Account</span>
          </router-link>
  
          <router-link v-if="roles == '1' || roles == '3'" to="/wallet" class="menu-item">
            <i class="fa fa-users"></i>
            <span>View Farmers</span>
          </router-link>
  
          <router-link v-if="roles == '1'" to="/admin-wallet" class="menu-item">
            <i class="fa fa-user-shield"></i>
            <span>Admin Farmers</span>
          </router-link>
  
          <router-link v-if="roles == '1' || roles == '2'" to="/registered-farmers" class="menu-item">
            <i class="fa fa-check-circle"></i>
            <span>Farmers Report</span>
          </router-link>
  
          <router-link v-if="roles == '1' || roles == '4'" to="/farmers" class="menu-item">
            <i class="fa fa-user-plus"></i>
            <span>Register Farmers</span>
          </router-link>
  
          <router-link v-if="roles == '1' || roles == '4'" to="/lands" class="menu-item">
            <i class="fa fa-map"></i>
            <span>Register Land</span>
          </router-link>
  
          <div class="menu-item logout" @click="vendorLogout">
            <i class="fa fa-sign-out"></i>
            <span>Logout</span>
          </div>
        </nav>
      </aside>
  
      <!-- Main -->
      <div class="main">
  
        <!-- Topbar -->
        <header class="topbar">
          <button class="menu-toggle" @click="toggleSidebar">
            <i class="fa fa-bars"></i>
          </button>
  
          <div class="user-area">
            <i class="fa fa-bell"></i>
            <span class="username">{{ username }}</span>
          </div>
        </header>
  
        <!-- Page Content -->
        <main class="content">
          <router-view />
        </main>
  
        <!-- Footer -->
        <footer class="footer">
          © {{ new Date().getFullYear() }} {{ appTitle }}. All rights reserved.
        </footer>
  
      </div>
    </div>
</template>

<script>
import inactivityMixin from '../mixins/inactivityMixin';
export default {

    name: "Dashboard",
    mixins: [inactivityMixin],
    components: {

    },

    data(){
        return {
            appTitle: 'Angala Farmers',
            username: '',
            email: '',
            name_initial: '',
            pageTitle: '',
            isMenuOpen: false,
            user: {
                avatar: ''
            },
            roles: '',
            isOpen: false,
        };
    },

    created() {
    this.$root.$on('title', (title) => {
      this.pageTitle = title;
        });
    },
    beforeDestroy() {
        this.$root.$off('title');
    },
      
    beforeMount(){
        document.title = this.appTitle
    },
    mounted() {
        this.username = localStorage.getItem("username");
        this.email = localStorage.getItem("email");
        this.roles = localStorage.getItem("roles");

        if (this.firstname) {
        this.name_initial = this.firstname.charAt(0);
        } else {
        this.name_initial = ''; // Handle the case where firstname is empty
        }
    },
   
    computed: {
        
    },
    methods:{
        toggleSidebar() {
        this.isOpen = !this.isOpen;
        },
        show_menu(){
            this.isMenuOpen = true; // Show the submenu-bar
        },
        close_menu(router){
            this.isMenuOpen = false; // Show the submenu-bar
            this.$router.push(router)
        },
        vendorLogout(){
            localStorage.removeItem("wertyuiojhdfghhdrtfyguh")
            localStorage.removeItem("username");
            localStorage.removeItem("lastname");
            localStorage.removeItem("phone");
            localStorage.removeItem("email");
            localStorage.removeItem("userid");
            this.$router.push("/login")
        }
    }
}
</script>

<style scoped>
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap');
  
  * {
    font-family: Poppins, sans-serif;
  }
  
  .layout {
    display: flex;
    min-height: 100vh;
    background: #f5f7fb;
  }
  
  /* Sidebar */
  .sidebar {
    width: 250px;
    background: linear-gradient(180deg, #111, #1c1c1c);
    color: #fff;
    position: fixed;
    height: 100%;
    left: 0;
    top: 0;
    transition: 0.3s ease;
    z-index: 1000;
  }
  
  .sidebar-header {
    padding: 25px 20px;
    text-align: center;
    border-bottom: 1px solid rgba(255,255,255,0.08);
  }
  
  .sidebar-header img {
    width: 70px;
    margin-bottom: 10px;
  }
  
  .sidebar-header h5 {
    margin: 0;
    font-size: 14px;
    font-weight: 500;
  }
  
  .menu {
    padding: 10px;
  }
  
  .menu-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 14px;
    color: #cfcfcf;
    text-decoration: none;
    border-radius: 10px;
    margin-bottom: 6px;
    transition: 0.2s;
    font-size: 13px;
  }
  
  .menu-item i {
    width: 18px;
    text-align: center;
  }
  
  .menu-item:hover {
    background: #d33e74;
    color: #fff;
    transform: translateX(4px);
  }
  
  .logout {
    cursor: pointer;
    margin-top: 20px;
    background: rgba(255,255,255,0.05);
  }
  
  /* Main */
  .main {
    margin-left: 250px;
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  
  /* Topbar */
  .topbar {
    height: 60px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    box-shadow: 0 2px 6px rgba(0,0,0,0.05);
  }
  
  .menu-toggle {
    border: none;
    background: none;
    font-size: 20px;
    display: none;
  }
  
  .user-area {
    display: flex;
    align-items: center;
    gap: 15px;
    font-size: 14px;
  }
  
  /* Content */
  .content {
    flex: 1;
    padding: 0;
    width: 100%;
  }
  
  /* Footer */
  .footer {
    text-align: center;
    padding: 12px;
    background: #fff;
    font-size: 12px;
    color: #777;
  }
  
  /* Overlay */
  .overlay {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.4);
    z-index: 900;
  }
  
  /* Mobile */
  @media (max-width: 768px) {
  
    .sidebar {
      transform: translateX(-100%);
      width: 260px;
    }
  
    .sidebar.open {
      transform: translateX(0);
    }
  
    .main {
      margin-left: 0;
    }
  
    .menu-toggle {
      display: block;
    }
  }
  </style>